import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=4a296706&scoped=true&"
import script from "./SubHeader.vue?vue&type=script&lang=js&"
export * from "./SubHeader.vue?vue&type=script&lang=js&"
import style0 from "./SubHeader.vue?vue&type=style&index=0&id=4a296706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a296706",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/SubHeader.vue
// module id = null
// module chunks = 